export const MAX_ALERT_TIME = 3000;
